<template>
  <NoHeaderLayout
    :userRole="activeUserRole"
    :imageLogo="defaultImage"
    headerTitle="Analyze"
  >
    <div class="lst-container">
      <div class="lst-card lst-cln-sp12 lst-row">
        <div class="lst-container-input lst-column">
          <label for="fromDateSection">From</label>
          <DxDateBox
            v-model="fromDateSection"
            picker-type="rollers"
            id="fromDateSection"
            min="2022-01-01"
            :max="new Date()"
          />
        </div>

        <div class="lst-container-input lst-column">
          <label for="toDateSection">To</label>
          <DxDateBox
            v-model="toDateSection"
            picker-type="rollers"
            id="toDateSection"
            min="2022-01-01"
            :max="new Date()"
          />
        </div>

        <div class="lst-container-input lst-column">
          <label for="audit">Audit</label>
          <DxDropDownBox
            ref="dropDownBox"
            :defer-rendering="false"
            :show-clear-button="true"
            placeholder="Select..."
            id="audit"
            :drop-down-options="{ height: 600, width: 550 }"
            @value-changed="onDropdownValueChanged"
          >
            <template #content="{ data }">
              <DxDataGrid
                ref="dataGrid"
                :data-source="templateFilterOptions"
                :hover-state-enabled="true"
                :selection="{ mode: 'single', deferred: false }"
                :remote-operations="false"
                :allow-column-sorting="false"
                :show-column-headers="false"
                :height="'100%'"
                :repaint-changes-only="true"
                @selection-changed="onTemplateSelectionChanged"
              >
                <DxSearchPanel
                  :visible="true"
                  :width="240"
                  placeholder="Search templates..."
                  :search-visible-columns-only="false"
                />
                <DxColumn data-field="name" :allow-sorting="false" :show-in-column-chooser="false" />
                <DxPaging :enabled="true" :page-size="15" />
                <DxPager
                  :visible="true"
                  :show-page-size-selector="false"
                  :show-info="true"
                  display-mode="full"
                />
              </DxDataGrid>
            </template>
          </DxDropDownBox>
        </div>

        <div class="lst-container-input lst-column lst-location">
          <label for="location">Location</label>
          <div class="location-tag-box-container">
            <dx-tag-box
              :key="selectedTemplate ? selectedTemplate.uuid : 'no-template'"
              :items="locationFilterOptions"
              display-expr="premise"
              value-expr="id"
              v-model="selectedLocation"
              placeholder="Select..."
              apply-value-mode="'instantly'"
              :show-selection-controls="true"
              style="min-width: 200px"
            />
            <DxButton
              v-if="selectedLocation.length"
              text="Deselect All"
              type="default"
              styling-mode="contained"
              @click="selectedLocation = []"
              class="deselect-button"
            />
          </div>
        </div>

        <!-- <div class="lst-container-input">
          <a>
            <ContentSaveIcon />
          </a>
        </div> -->

        <!-- <div class="lst-container-input lst-right">
          <button class="lst-download-btn" @click="onDownloadCSV('all')">
            <DownloadIcon />
          </button>
        </div> -->

        <div class="lst-container-input lst-right">
          <DxButton
            text="Run"
            type="default"
            styling-mode="contained"
            :disabled="selectedTemplate === null || !selectedLocation.length"
            @click="runDashboard"
          />
        </div>
      </div>

      <div class="lst-card lst-cln-sp3 lst-row-sp1">
        <h3>Total Audits</h3>
        <h1>{{ totalAudits }}</h1>
        <hr />
        <h4>{{ totalLocations }} locations</h4>
      </div>

      <div class="lst-card lst-cln-sp3 lst-row-sp1">
        <h3>Average Audit Score</h3>
        <h1>{{ averageScore }}%</h1>
        <hr />
        <h4>{{ totalLocations }} locations</h4>
      </div>

      <div class="lst-card lst-cln-sp6 lst-row-sp1">
        <h3 class="lst-title">
          Location Ranking
          <!-- <a class="lst-download-btn">
            <DownloadIcon />
          </a> -->
          <button
            class="lst-download-btn"
            @click="onDownloadCSV('locationRanking')"
          >
            <DownloadIcon />
          </button>
        </h3>
        <table class="lst-tbl-location-ranking">
          <thead>
            <tr>
              <td>Name</td>
              <td>Score</td>
              <td>Rank</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(location, index) in locationRanking" :key="index">
              <td>{{ location.location_name }}</td>
              <td class="lst-flex-row">
                <label class="lst-score">{{ roundTo1(location.avg_score * 100) }}%</label>
                <div class="lst-progress-bar">
                  <div
                    class="lst-pb-full"
                    :style="{ width: location.avg_score * 100 + '%' }"
                  ></div>
                  <!-- <div
                    class="lst-pb-empty"
                    :style="{ width: (1 - location.avg_score) * 100 + '%' }"
                  ></div> -->
                </div>
              </td>
              <td>{{ index + 1 }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="lst-card lst-cln-sp6 lst-row-sp2">
        <h3 class="lst-title">
          Average Audit Score
          <button
            class="lst-download-btn"
            @click="onDownloadCSV('averageAuditScore')"
          >
            <DownloadIcon />
          </button>
        </h3>

        <div class="lst-chart">
          <canvas ref="barChart"></canvas>
        </div>
      </div>

      <div class="lst-card lst-cln-sp6 lst-row-sp2">
        <h3 class="lst-title">
          Section Performance
          <button
            class="lst-download-btn"
            @click="onDownloadCSV('sectionPerformance')"
          >
            <DownloadIcon />
          </button>
        </h3>
        <div class="table-container">
          <table class="lst-tbl-section-performance">
            <thead>
              <tr>
                <td
                  v-for="(column, index) in sectionPerformance.columns"
                  :key="index"
                >
                  {{
                    column == "section_name"
                      ? "Section"
                      : column == "overall_average"
                      ? "Overall Average"
                      : column
                  }}
                </td>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(section, index) in sectionPerformance.rows"
                :key="index"
              >
                <td
                  v-for="(column, index) in sectionPerformance.columns"
                  :key="index"
                >
                  {{ section[column] }}
                </td>
                <!-- <td>{{ section.section }}</td>
                <td>{{ section.pass }}</td>
                <td>{{ section.total }}</td>
                <td>{{ section.percentage_passed }}</td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="lst-card lst-cln-sp12 lst-row-sp2">
        <h3 class="lst-title">
          Question Performance
          <button
            class="lst-download-btn"
            @click="onDownloadCSV('questionPerformance')"
          >
            <DownloadIcon />
          </button>
        </h3>
        <table class="lst-tbl-question-performance">
          <thead>
            <tr>
              <td>Section</td>
              <td>Question</td>
              <td>Passed</td>
              <td>Total</td>
              <td>%</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(question, index) in questionPerformance" :key="index">
              <td>{{ question.section }}</td>
              <td>{{ question.question }}</td>
              <td>{{ question.pass }}</td>
              <td>{{ question.total }}</td>
              <td>{{ question.percentage_passed }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </NoHeaderLayout>
</template>
  
<script>
import { chain } from "lodash";
import API from "@/services/API";
import DxDropDownBox from "devextreme-vue/drop-down-box";
import DxTagBox from "devextreme-vue/tag-box";
import { sync } from "vuex-pathify";
import ImageLogo from "@/assets/images/respro-logo.svg";
import DxButton from "devextreme-vue/button";
import {
  DxDataGrid as DxDataGridComponent,
  DxColumn as DxDataGridColumn,
  DxPaging as DxDataGridPaging,
  DxPager,
  DxSelection,
  DxSearchPanel,
} from "devextreme-vue/data-grid";
import DataSource from "devextreme/data/data_source";
import {
  DxArgumentAxis,
  DxChart,
  DxSeries,
  DxCommonAxisSettings,
  DxMargin,
  DxCommonSeriesSettings,
  DxGrid,
  DxValueAxis,
} from "devextreme-vue/chart";
import DxDateBox from "devextreme-vue/date-box";
import {
  DxLegend,
  DxTitle,
  DxTooltip,
  DxFormat,
  DxLabel,
  DxExport,
} from "devextreme-vue/pie-chart";
import NoHeaderLayout from "../../layouts/NoHeaderLayout.vue";
// import UtilService from "../../services/utilservice";

import ContentSaveIcon from "vue-material-design-icons/ContentSave.vue";
import DownloadIcon from "vue-material-design-icons/Download.vue";
import Chart from "chart.js";

const chartIndicatorSources = [
  { value: "score", name: "Score" },
  { value: "score_percentage", name: "Score Percentage" },
];

let date = new Date();

date = date.setMonth(date.getMonth() - 1);

export default {
  name: "Home",
  components: {
    DxGrid,
    DxMargin,
    DxCommonAxisSettings,
    DxArgumentAxis,
    DxTitle,
    DxButton,
    DxChart,
    DxDateBox,
    DxLegend,
    DxSeries,
    DxTooltip,
    DxFormat,
    DxLabel,
    DxDropDownBox,
    DxDataGrid: DxDataGridComponent,
    DxColumn: DxDataGridColumn,
    DxPaging: DxDataGridPaging,
    DxPager,
    DxSelection,
    DxSearchPanel,
    DxTagBox,
    DxExport,
    DxCommonSeriesSettings,
    NoHeaderLayout,
    DxValueAxis,
    ContentSaveIcon,
    DownloadIcon,
    Chart,
  },
  data() {
    return {
      defaultImage: ImageLogo,
      totalNumberOfAuditsSubmitted: 0,
      performanceOverTimeData: [],
      performanceLocationData: [],

      complianceSectionPerformace: [],
      complianceByQuestionDataWorst: [],
      complianceByLocationDataBest: [],
      locationFilterOptions: [],
      locationIndicatorSources: [
        // { value: '2176a280-4732-4f89-8790-fb3607be95b1', name: 'Adane' },
        // { value: 'ca939a63-10c9-4398-9bf5-313df4cf60d6', name: 'Brevard' },
        // { value: 'b6f96306-434c-4ec9-8a4d-47e774fd74b1', name: 'Brevard' },
        // { value: '68271baa-580b-4525-a773-5b05a0874008', name: 'emc245' },
        // { value: '3ec8c263-80b9-4742-be36-e08e3d353e08', name: 'Postsdam Restaurant' },
        // { value: '422ca54d-8baa-42be-8149-ea51d5ce38b1', name: 'Roadhouse' },
      ],

      selectedLoactions: [
        // { uuid: '2176a280-4732-4f89-8790-fb3607be95b1', name: 'Adane' },
        // { uuid: 'ca939a63-10c9-4398-9bf5-313df4cf60d6', name: 'Brevard' },
        // { uuid: 'b6f96306-434c-4ec9-8a4d-47e774fd74b1', name: 'Brevard' },
        // { uuid: '68271baa-580b-4525-a773-5b05a0874008', name: 'emc245' },
        // { uuid: '3ec8c263-80b9-4742-be36-e08e3d353e08', name: 'Postsdam Restaurant' },
        // { uuid: '422ca54d-8baa-42be-8149-ea51d5ce38b1', name: 'Roadhouse' },
      ],

      templateFilterOptions: null,
      templatePage: 1,
      hasMoreTemplates: false,
      brandFilterOptions: [],
      fromDateSection: date,
      toDateSection: new Date(),
      fromDateQuestion: date,
      toDateQuestion: new Date(),
      selectedLocation: [],
      selectedTemplate: null,
      selectedTemplateValue: null,
      selectedTemplateDisplayValue: null,
      selectedGroup: null,
      dropdownOpened: false,
      isSettingTemplate: false,
      isLoadingPremises: false,
      activeLoadingComponents: [],
      chartIndicatorSources,
      formattedDate: "",
      isAvailableLocationModal: false,

      totalAudits: 0,
      totalLocations: 0,
      averageScore: 0,
      locationRanking: [],
      dailyTemplateScores: [],
      sectionPerformance: [],
      questionPerformance: [],
      auditChart: null,
    };
  },
  computed: {
    premises: sync("app/premises"),
    activeUserRole: sync("app/activeUserRole"),
    token: sync("app/session"),
    currentAuditIndex: sync("audit/currentAuditIndex"),
    audits: sync("audit/audits"),
    location: sync("audit/audits[:currentAuditIndex]@location"),
    selectedAuditUuid: sync("audit/selectedAuditUuid"),
    allPremises: sync("premises/premises"),
    groups: sync("premises/groups"),
    activeTemplates: sync("app/activeTemplates"),
    selectedRowKeys() {
      // Don't update selected keys while programmatically setting to avoid triggering selection-changed
      if (this.isSettingTemplate) {
        return this.selectedTemplate ? [this.selectedTemplate.uuid] : [];
      }
      return this.selectedTemplate ? [this.selectedTemplate.uuid] : [];
    },
    selectedLocationUuids: {
      get() {
        return this.selectedLoactions.map((i) => i.uuid);
      },
      set(value) {
        this.selectedLoactions = this.locationFilterOptions.filter((i) =>
          value.includes(i.uuid)
        );
        this.locationIndicatorSources = this.locationFilterOptions
          .filter((i) => value.includes(i.uuid))
          .map((x) => {
            return {
              name: x.name,
              value: x.uuid,
            };
          });
      },
    },
    getGraphColor() {
      return (value) => {
        switch (value) {
          case 0:
            return ["#2196f3", "#aad7fa"];
          case 1:
            return ["#673ab7", "#c5b4e3"];
          case 2:
            return ["#c6282e", "#f9d9d9"];
          case 3:
            return ["#ffc14d", "#fff8e1"];
          case 4:
            return ["#00e676", "#e5fceb"];
          case 5:
            return ["#bbff00", "#f0fad4"];
          case 6:
            return ["#5d0ceb", "#d3c2f0"];
          case 7:
            return ["#f2029a", "#ebb5d7"];
          case 8:
            return ["#05b1e6", "#d1e8f0"];
          case 9:
            return ["#1a8215", "#9db59c"];
          default:
            return ["#00e676", "#e5fceb"];
        }
      };
    },
    getDateExportName() {
      return (date1, date2, extraString) => {
        const fromDate = new Date(date1);
        const yearFrom = fromDate.getFullYear();
        const monthFrom = fromDate.getMonth() + 1;
        const dayFrom = fromDate.getDate();
        const formattedFromDate = `${yearFrom}_${monthFrom
          .toString()
          .padStart(2, "0")}_${dayFrom.toString().padStart(2, "0")}`;

        const toDate = new Date(date2);
        const yearTo = toDate.getFullYear();
        const monthTo = toDate.getMonth() + 1;
        const dayTo = toDate.getDate();
        const formattedToDate = `${yearTo}_${monthTo
          .toString()
          .padStart(2, "0")}_${dayTo.toString().padStart(2, "0")}`;

        return formattedFromDate + "-" + formattedToDate + "_" + extraString;
      };
    },
  },
  methods: {
    getDisplayText(item) {
      return item ? item.name : "";
    },
    onDropdownValueChanged(e) {
      // Ignore if we're in the middle of setting the template from selection
      if (this.isSettingTemplate) {
        return;
      }

      // Handle clear button - when value is being cleared
      if (!e.value && e.previousValue) {
        this.selectedTemplate = null;
        this.selectedTemplateDisplayValue = null;
      }
    },
    onTemplateSelectionChanged(e) {
      console.log("onTemplateSelectionChanged called", {
        isSettingTemplate: this.isSettingTemplate,
        currentSelectedRowKeys: e.currentSelectedRowKeys,
        selectedRowsData: e.selectedRowsData
      });

      // Ignore events that fire while we're programmatically setting the template
      if (this.isSettingTemplate) {
        console.log("Ignoring - isSettingTemplate is true");
        return;
      }

      // Only process if currentSelectedRowKeys has items (ignore deselection events)
      if (!e.currentSelectedRowKeys || e.currentSelectedRowKeys.length === 0) {
        console.log("Ignoring - deselection event");
        return;
      }

      const selectedRows = e.selectedRowsData;
      if (selectedRows.length > 0) {
        // Check if we're selecting the same template again (ignore duplicate events)
        if (this.selectedTemplate && this.selectedTemplate.uuid === selectedRows[0].uuid) {
          console.log("Ignoring - same template already selected");
          return;
        }

        console.log("Processing selection:", selectedRows[0].name);

        // Set flag to prevent recursive calls
        this.isSettingTemplate = true;

        this.selectedTemplate = selectedRows[0];
        this.selectedTemplateDisplayValue = this.selectedTemplate.name;

        const dropDownInstance = this.$refs.dropDownBox?.instance;

        // Call onAuditChange to load locations FIRST
        console.log("Calling onAuditChange");
        this.onAuditChange();

        // Close dropdown and update display after a tiny delay
        setTimeout(() => {
          if (dropDownInstance) {
            // Get the input element and clear it completely first
            const inputElement = dropDownInstance._$element.find('input.dx-texteditor-input');
            console.log("Input element found:", inputElement.length);

            if (inputElement.length > 0) {
              // Clear the input completely
              inputElement.val('');
              inputElement.attr('value', '');
              inputElement.removeAttr('placeholder');

              // Now set the new value
              inputElement.val(this.selectedTemplate.name);
              inputElement.attr('value', this.selectedTemplate.name);

              // Force a repaint to ensure the text displays correctly
              inputElement[0].dispatchEvent(new Event('input', { bubbles: true }));

              console.log("Set input value to:", this.selectedTemplate.name);
            }

            // Also try to update the wrapper element's text
            const textContainer = dropDownInstance._$element.find('.dx-texteditor-container');
            if (textContainer.length > 0) {
              textContainer.attr('data-value', this.selectedTemplate.name);
            }

            // Close the dropdown after setting the value
            console.log("Closing dropdown after delay");
            dropDownInstance.close();
          }
        }, 10);

        // Reset flag after longer delay to allow all events to settle
        setTimeout(() => {
          this.isSettingTemplate = false;
          console.log("Reset isSettingTemplate to false");
        }, 500);
      }
    },
    onDropdownOpened() {
      console.log("!!! DROPDOWN OPENED - This should NOT happen after selection !!!");
      console.log("Stack trace:", new Error().stack);
      // Prevent DataGrid from reloading when dropdown reopens
      if (this.$refs.dataGrid && this.$refs.dataGrid.instance) {
        const gridInstance = this.$refs.dataGrid.instance;
        gridInstance.refresh(false);
      }
    },
    handleSectionPerformance(data) {
      const rows = data ? data : [];
      const columns = data.length > 0 ? Object.keys(data[0]) : [];

      return { rows, columns };
    },
    onDownloadCSV(file) {
      if (this.selectedTemplate !== null && this.selectedLocation.length) {
        const fromDate = this.formatDate(new Date(this.fromDateSection));
        const toDate = this.formatDate(this.toDateSection);

        let fileName = `${fromDate}_${toDate}_${this.selectedTemplate.name
          .toLowerCase()
          .replace(/\s+/g, "-")}_`;
        let request = null;

        if (file == "averageAuditScore") {
          fileName += "average-auditScore";
          request = API.fetch_dashboard_daily_template_scores(
            this.token,
            fromDate,
            toDate,
            this.selectedTemplate.uuid,
            this.selectedLocation,
            true
          );
        } else if (file == "sectionPerformance") {
          fileName += "section-performance";
          request = API.fetch_dashboard_section_performance(
            this.token,
            fromDate,
            toDate,
            this.selectedTemplate.uuid,
            this.selectedLocation,
            true
          );
        } else if (file == "questionPerformance") {
          fileName += "question-performance";
          request = API.fetch_dashboard_question_performance(
            this.token,
            fromDate,
            toDate,
            this.selectedTemplate.uuid,
            this.selectedLocation,
            true
          );
        } else if (file == "locationRanking") {
          fileName += "location-ranking";
          request = API.fetch_dashboard_average_audit_score(
            this.token,
            fromDate,
            toDate,
            this.selectedTemplate.uuid,
            this.selectedLocation,
            null,
            true
          );
        } else if (file == "all") {
          this.onDownloadCSV("averageAuditScore");
          this.onDownloadCSV("sectionPerformance");
          this.onDownloadCSV("questionPerformance");
          this.onDownloadCSV("locationRanking");
        }

        if (request) {
          const loadingComponent = this.$buefy.loading.open({
            container: null,
          });
          request
            .then((response) => {
              let blob;
              
              if (response.data instanceof Blob) {
                blob = response.data;
              } else {
                const csvContent = typeof response === "string" ? response : response.data;
                blob = new Blob([csvContent], {
                  type: "text/csv;charset=utf-8;",
                });
              }

              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", `${fileName}.csv`);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);

              loadingComponent.close();
            })
            .catch((error) => {
              console.log(error);
              loadingComponent.close();
              this.$buefy.dialog.alert("Error downloading data.");
            });
        }
      } else {
        this.$buefy.dialog.alert(
          "At least one Audit and one Location must be selected!"
        );
      }
    },
    onAuditChange() {
      // Guard against multiple simultaneous calls
      if (this.isLoadingPremises) {
        return;
      }

      this.selectedLocation = [];

      if (this.selectedTemplate && this.selectedTemplate.uuid) {
        this.isLoadingPremises = true;

        // First, force close any existing loading components
        if (this.activeLoadingComponents.length > 0) {
          this.activeLoadingComponents.forEach(comp => {
            try {
              comp.close();
            } catch (e) {
              console.error("Error closing existing loading component:", e);
            }
          });
          this.activeLoadingComponents = [];
        }

        const loadingComponent = this.$buefy.loading.open({
          container: null,
          canCancel: true
        });

        // Track this loading component
        this.activeLoadingComponents.push(loadingComponent);

        // Add a timeout to prevent indefinite loading
        const timeoutId = setTimeout(() => {
          this.isLoadingPremises = false;
          try {
            if (loadingComponent && typeof loadingComponent.close === 'function') {
              loadingComponent.close();
            }
          } catch (e) {
            console.error("Error closing loading on timeout:", e);
          }
          this.$buefy.dialog.alert("Request timed out. Please try again.");
        }, 30000); // 30 second timeout

        API.fetch_premises_by_template(
          this.token,
          this.selectedTemplate.uuid
        )
          .then((premises) => {
            clearTimeout(timeoutId);

            // Validate response
            if (!premises || !premises.data || !Array.isArray(premises.data)) {
              this.$buefy.dialog.alert("Error: Invalid response format from server.");
              return;
            }

            // Sort locations
            try {
              const sortedLocations = premises.data.sort((a, b) => {
                const premiseA = a.premise || '';
                const premiseB = b.premise || '';
                return premiseA.localeCompare(premiseB, undefined, { numeric: true, sensitivity: 'base' });
              });
              this.locationFilterOptions = sortedLocations;
            } catch (sortError) {
              console.error("Error during sorting:", sortError);
              this.locationFilterOptions = premises.data;
            }
          })
          .catch((error) => {
            console.error("Error fetching premises:", error);
            clearTimeout(timeoutId);
            this.$buefy.dialog.alert("Error fetching premises: " + (error.message || "Unknown error"));
          })
          .finally(() => {
            this.isLoadingPremises = false;

            // Close the loading component
            try {
              if (loadingComponent && typeof loadingComponent.close === 'function') {
                loadingComponent.close();

                // Remove from tracking array
                const index = this.activeLoadingComponents.indexOf(loadingComponent);
                if (index > -1) {
                  this.activeLoadingComponents.splice(index, 1);
                }
              }
            } catch (closeError) {
              console.error("Error closing loading component:", closeError);
            }

            // Safety: Force close any remaining loading overlays in DOM
            this.$nextTick(() => {
              const loadingOverlays = document.querySelectorAll('.loading-overlay.is-active');
              if (loadingOverlays.length > 0) {
                loadingOverlays.forEach(overlay => {
                  overlay.classList.remove('is-active');
                  overlay.style.display = 'none';
                });
              }
            });
          });
      }
    },
    renderChart() {
      this.auditChart.data.labels = this.dailyTemplateScores.map(
        (row) => row.period
      );
      this.auditChart.data.datasets[0].data = this.dailyTemplateScores.map((row) =>
        this.roundTo1(row.score * 100)
      );

      this.auditChart.update();
    },
    onBack() {
      this.currentAuditIndex = -1;
      this.$router.push({ name: "home" });
    },
    toggleButtonClick() {
      this.isAvailableLocationModal = !this.isAvailableLocationModal;
    },
    onInitial() {
      // Use templates from login instead of making API calls
      // Create a DataSource with local data for client-side pagination and search
      this.templateFilterOptions = new DataSource({
        store: this.activeTemplates || [],
        key: "uuid",
        paginate: true,
        pageSize: 15,
      });

      this.brandFilterOptions = [];
    },
    onGetComplianceBySection(dataSource) {
      this.complianceSectionPerformace = dataSource;

      // const filteringData = this.selectedTemplate
      //   ? dataSource.filter(x => x.template_name === this.selectedTemplate.name)
      //   : dataSource;

      // const groupByCategory = chain(filteringData)
      //   .groupBy('category_text')
      //   .map((val, category_text) => ({ val, category_text }))
      //   .value();

      // const formattedGrouping = groupByCategory.map(i => {
      //   const item = i["val"]
      //   const cat = i["category_text"]
      //   const score = item.reduce((p, n) => {
      //     return p + Number(n.is_passed ? 1 : 0)
      //   }, 0)
      //   i['score'] = parseInt(score);
      //   i["category_text"] = cat;
      //   i['failed'] = item.length - i['score'];
      //   return i
      // })

      // this.complianceSectionPerformace =
      //   formattedGrouping
      //     .slice()
      //     .sort((a, b) => b.failed - a.failed)
      //     // .slice(0, 10);

      // this.complianceSectionPerformace.forEach(x => {
      //   x.val = x.val.length;
      // });
    },
    onGetComplianceByQuestion(dataSource) {
      this.complianceByQuestionDataWorst = dataSource;
      // const filteringData = this.selectedTemplate
      //   ? dataSource.filter(x => x.template_name === this.selectedTemplate.name)
      //   : dataSource;

      // const groupByCategory = chain(filteringData)
      //   .groupBy('question_text')
      //   .map((val, question_text) => ({ val, question_text }))
      //   .value();

      // const formattedGrouping = groupByCategory.map(i => {
      //   const item = i["val"]
      //   const cat = i["question_text"]
      //   const score = item.reduce((p, n) => {
      //     return p + (n.is_passed === true ? 1 : 0)
      //   }, 0)
      //   i['score'] = parseInt(score);
      //   i["question_text"] = cat;
      //   i['failed'] = item.length - i['score'];
      //   return i
      // })

      // this.complianceByQuestionDataWorst =
      //   formattedGrouping
      //     .slice()
      //     .sort((a, b) => b.failed - a.failed)
      //     // .slice(0, 10);

      // this.complianceByQuestionDataWorst.forEach(x => {
      //   x.val = x.val.length;
      // });
    },
    onGetComplianceByLocation(dataSource) {
      this.complianceByLocationDataBest = dataSource.map((item) => {
        return { ...item, percentage: (item.avg_score * 100).toFixed(2) + "%" };
      });
      // const filteringData = this.selectedTemplate
      //   ? dataSource.filter(x => x.template_name === this.selectedTemplate.name)
      //   : dataSource;

      // const groupByCategory = chain(filteringData)
      //   .groupBy('location_uuid')
      //   .map((val, location_uuid) => ({ val, location_uuid }))
      //   .value();

      // const formattedGrouping = groupByCategory.map(i => {
      //   const item = i["val"]
      //   const cat = i["location_uuid"]
      //   const score = item.reduce((p, n) => {
      //     return p + (n.is_passed ? 1 : 0)
      //   }, 0)
      //   i['score'] = parseInt(score);
      //   i["location_uuid"] = cat;
      //   const locationObject = this.locationFilterOptions.find(x => x.uuid === i["location_uuid"]);
      //   i["location_name"] = locationObject ? locationObject.name : '-';
      //   i['failed'] = item.length - i['score'];
      //   return i
      // })

      // this.complianceByLocationDataBest = formattedGrouping
      //   .slice()
      //   .sort((a, b) => a.score / a.val.length - b.score / b.val.length)
      //   .filter(x => x.location_name !== '-')
      //   // .slice(0, 5)

      // this.complianceByLocationDataBest.forEach(x => {
      //   x.val = x.val.length;
      // });
    },
    onGetAuditSubmitted(dataSource) {
      const groupByDateSubmitted = chain(dataSource)
        .groupBy("date_submitted")
        .map((val, date_submitted) => ({ val, date_submitted }))
        .value();

      const formattedDateGrouping = groupByDateSubmitted.map((i) => {
        const item = i["val"];
        const score = item.reduce((p, n) => {
          return p + Number(n.score);
        }, 0);
        const score_percentage = item.reduce((p, n) => {
          return p + Number(n.score_percentage);
        }, 0);

        i["score"] = score;
        i["score_percentage"] = parseInt(score_percentage);
        return i;
      });
      this.performanceOverTimeData = formattedDateGrouping;
    },
    onGetLocationScores(dataSource) {
      const filteringData = dataSource;

      const groupByDateLocation = chain(filteringData)
        .groupBy((data) => data.month)
        .map((val, month) => ({ val, month }))
        .value();

      const performanceLocationData = groupByDateLocation.map((i) => {
        const item = i["val"];
        const groupByDateLocation = chain(item)
          .groupBy("location_uuid")
          .map((val, location_uuid) => ({ val, location_uuid }))
          .value();
        groupByDateLocation.forEach((data) => {
          i[data.location_uuid] = parseInt(
            data.val.reduce((p, n) => {
              return p + Number(n.avg_score * 100);
            }, 0)
          );
        });

        return i;
      });
      this.performanceLocationData = performanceLocationData.sort((a, b) => {
        return new Date(a.month) - new Date(b.month);
      });
    },

    onRunReportCompliance() {
      this.onRunReportComplianceByQuestion();
      this.onRunReportComplianceBySection();
    },
    onRunReportComplianceBySection() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      const fromDate = new Date(this.fromDateQuestion);
      const toDate = new Date(this.toDateQuestion);
      const fromDateString = `${fromDate.getFullYear()}-${
        fromDate.getMonth() + 1
      }-${fromDate.getDate()} 00:00:00.000-600`;
      const toDateString = `${toDate.getFullYear()}-${
        toDate.getMonth() + 1
      }-${toDate.getDate()} 00:00:00.000-600`;
      // const locationUuid = this.selectedLocation == null ? '' : this.selectedLocation.uuid
      const templateUuid =
        this.selectedTemplate == null ? "" : this.selectedTemplate.uuid;
      const params = `fromDate=${fromDateString}&toDate=${toDateString}&locationUuids=${this.selectedLocationUuids}&templateUuid=${templateUuid}`;

      Promise.all([
        API.fetch_dashboard_section_performance_aggregated(this.token, params),
        // API.fetch_dashboard_number_of_audits_submitted(this.token, params),
        // API.fetch_dashboard_average_score(this.token, params)
      ])
        .then((responses) => {
          const [genericData] = responses;
          this.dataSource = genericData.data;
          this.onGetComplianceBySection(genericData.data);
          loadingComponent.close();
        })
        .catch((error) => {
          console.log(error);
          loadingComponent.close();
          this.$buefy.dialog.alert("Error fetching account information.");
        });
    },
    onRunReportComplianceByLocation() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      const fromDate = new Date(this.fromDateSection);
      const toDate = new Date(this.toDateSection);
      const fromDateString = `${fromDate.getFullYear()}-${
        fromDate.getMonth() + 1
      }-${fromDate.getDate()}`;
      const toDateString = `${toDate.getFullYear()}-${
        toDate.getMonth() + 1
      }-${toDate.getDate()}`;
      const premisesGroupUuid =
        this.selectedGroup == null ? "" : this.selectedGroup.uuid;
      const templateUuid =
        this.selectedTemplate == null ? "" : this.selectedTemplate.uuid;
      const params = `fromDate=${fromDateString}&toDate=${toDateString}&premisesGroupUuid=${premisesGroupUuid}&templateUuid=${templateUuid}`;

      Promise.all([
        API.fetch_dashboard_location_performance(this.token, params),
        API.fetch_dashboard_number_of_audits_submitted(this.token, params),
        API.fetch_dashboard_average_score(this.token, params),
      ])
        .then((responses) => {
          const [locationPerformance, numberOfAudits, averageScore] = responses;
          this.totalNumberOfAuditsSubmitted = numberOfAudits.data;
          this.averageScore = averageScore.data;
          this.onGetComplianceByLocation(locationPerformance.data); // audit scores
          loadingComponent.close();
        })
        .catch((error) => {
          console.log(error);
          loadingComponent.close();
          this.$buefy.dialog.alert("Error fetching account information.");
        });
    },
    onRunReportComplianceByQuestion() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      const fromDate = new Date(this.fromDateQuestion);
      const toDate = new Date(this.toDateQuestion);
      const fromDateString = `${fromDate.getFullYear()}-${
        fromDate.getMonth() + 1
      }-${fromDate.getDate()} 00:00:00.000-600`;
      const toDateString = `${toDate.getFullYear()}-${
        toDate.getMonth() + 1
      }-${toDate.getDate()} 00:00:00.000-600`;
      // const locationUuid = this.selectedLocation == null ? '' : this.selectedLocation.uuid
      const templateUuid =
        this.selectedTemplate == null ? "" : this.selectedTemplate.uuid;
      const params = `fromDate=${fromDateString}&toDate=${toDateString}&locationUuids=${this.selectedLocationUuids}&templateUuid=${templateUuid}`;

      Promise.all([
        API.fetch_dashboard_question_performance_aggregated(this.token, params),
      ])
        .then((responses) => {
          const [genericData] = responses;
          this.onGetComplianceByQuestion(genericData.data);
          loadingComponent.close();
        })
        .catch((error) => {
          console.log(error);
          loadingComponent.close();
          this.$buefy.dialog.alert("Error fetching account information.");
        });
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
    roundTo1(number) {
      return (Math.round(number * 10) / 10).toFixed(1);
    },
    runDashboard() {
      if (this.selectedTemplate !== null && this.selectedLocation.length) {
        const loadingComponent = this.$buefy.loading.open({ container: null });
        const fromDate = this.formatDate(new Date(this.fromDateSection));
        const toDate = this.formatDate(this.toDateSection);

        Promise.all([
          API.fetch_dashboard_total_audits(
            this.token,
            fromDate,
            toDate,
            this.selectedTemplate.uuid,
            this.selectedLocation,
            null
          ),
          API.fetch_dashboard_average_audit_score(
            this.token,
            fromDate,
            toDate,
            this.selectedTemplate.uuid,
            this.selectedLocation,
            null,
            false
          ),
          API.fetch_dashboard_location_ranking(
            this.token,
            fromDate,
            toDate,
            this.selectedTemplate.uuid,
            this.selectedLocation,
            null
          ),
          API.fetch_dashboard_daily_template_scores(
            this.token,
            fromDate,
            toDate,
            this.selectedTemplate.uuid,
            this.selectedLocation,
            false
          ),
          API.fetch_dashboard_section_performance(
            this.token,
            fromDate,
            toDate,
            this.selectedTemplate.uuid,
            this.selectedLocation,
            false
          ),
          API.fetch_dashboard_question_performance(
            this.token,
            fromDate,
            toDate,
            this.selectedTemplate.uuid,
            this.selectedLocation,
            false
          ),
        ])
          .then((responses) => {
            const [
              totalAudits,
              averageScore,
              locationRanking,
              dailyTemplateScores,
              sectionPerformance,
              questionPerformance,
            ] = responses;
            this.totalLocations = this.selectedLocation.length;
            this.totalAudits = totalAudits.data;
            this.averageScore = this.roundTo1(averageScore.data * 100);
            // this.locationRanking = [...locationRanking.data,...locationRanking.data];
            this.locationRanking = locationRanking.data;
            this.dailyTemplateScores = dailyTemplateScores.data.data;
            this.sectionPerformance = this.handleSectionPerformance(
              sectionPerformance.data
            );
            this.questionPerformance = questionPerformance.data;

            this.renderChart();
            loadingComponent.close();
          })
          .catch((error) => {
            console.log(error);
            loadingComponent.close();
            this.$buefy.dialog.alert("Error fetching data.");
          });
      } else {
        this.$buefy.dialog.alert(
          "At least one Audit and one Location must be selected!"
        );
      }
    },
    formatLabel(arg) {
      return `<span class="label">${arg.item.argument} </span>`;
    },
  },

  created() {
    this.onInitial();
    // this.onRunReportLocationScores(); // LocationScores
    // this.onRunReportComplianceByLocation(); // Audit Scores - Location Performance
    // this.onRunReportComplianceBySection(); // Section Performance
    // this.onRunReportComplianceByQuestion(); // Question Performance
  },
  mounted() {
    // this.renderChart();

    this.auditChart = new Chart(this.$refs.barChart, {
      type: "bar",
      data: {
        labels: this.dailyTemplateScores.map((row) => row.period),
        datasets: [
          {
            label: "Score",
            data: this.dailyTemplateScores.map((row) =>
              this.roundTo1(row.score * 100)
            ),
            backgroundColor: "rgba(59, 130, 246, 0.5)",
            borderColor: "rgba(59, 130, 246, 1)",
            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
    });
  },
};
</script>
<style src="./Dashboard.css"></style>